import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import Consent from '../../assets/images/consent.jpg'
import Data from '../../assets/images/data.jpg'
import Week from '../../assets/images/week.jpg'
import School from '../../assets/images/school.jpg'
import Patient from '../../assets/images/patient.jpg'
import Colorado from '../../assets/images/colorado.jpg'
import Tests from '../../assets/images/tests.jpg'
import { Link } from 'react-router-dom'
import PermissionsGate from '../../components/PermissionGate'
import useMe from '../../hooks/users/useMe'
import { SCOPES } from '../../utils/permissionsMap'

const Reports = () => {
  const { data: me } = useMe()

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            variant='h4'
            sx={{
              color: '#27417A',
              fontWeight: 'bold'
            }}
          >
            Reports
          </Typography>
        </Grid>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewMainReport]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/1'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Data}
                    alt='Excel Spreadsheet'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    Main Report
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewReport]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/2'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Consent}
                    alt='People shaking hands'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    Current Users Registered/Consented
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewCOReports]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/3'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Week}
                    alt='This Week'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    Weekly Consents for CO
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewCOReports]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/4'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={School}
                    alt='School'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    CO School Grade Report
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewCOReports]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/5'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Patient}
                    alt='Patient'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    CO Patient Report
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewCOReports]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/6'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Colorado}
                    alt='Colorado'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    CO Report
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
        <PermissionsGate
          user={me}
          scopes={[SCOPES.canViewMainReport]}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card>
              <Link
                to='/reports/7'
              >
                <CardActionArea>
                  <CardMedia
                    component='img'
                    height='140'
                    image={Tests}
                    alt='Total Tests'
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography 
                      gutterBottom 
                      component='div' 
                      variant='h6'
                      sx={{
                        textDecoration: 'underline',
                        color: '#27417A'
                      }}>
                    Total Tests By Month Per Organization
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Link>
            </Card>
          </Grid>
        </PermissionsGate>
      </Grid>
    </div>
  )
}

export default Reports